module.exports = __webpack_public_path__ + "img/泰安银行.e34155cc.png";